module.exports = __webpack_public_path__ + "static/asiapremium-b47af6d410a3faf19e0da37b7c353d71.png";